/* @flow */

import React from 'react';
import Box from '@material-ui/core/Box';

export default function AppWrapperComponent(props) {
  const bgColor = process.env.REACT_APP_ENV_NAME === "ACC" ? '#fdede8' : null;
  return <Box p={3} width="100%" bgcolor={bgColor}>{props.children}</Box>;
}
